import*as React from'react';var InitialReportPhotoPane=function InitialReportPhotoPane(props){return<>
      <div className="d-flex flex-wrap justify-content-between">
        {props.initialReportPhotos.map(function(photo,index){return<div key={photo.id}className={"mt-".concat(index<3?0:3)}style={{width:"30%"}}>
              <img className="w-100"src={photo.url}onClick={function(){props.onSelectPhoto(photo);}}/>
            </div>;})}
      </div>
    </>;};export default InitialReportPhotoPane;